module.exports = __webpack_public_path__ + "img/Rectangle 1586.5671cb14.svg";